/**
 * HTML `autocomplete` tokens for the funnel's field keys, so browsers offer saved name/contact/address data
 * (Chrome otherwise has to guess from name + label, which breaks easily). Only the hint is set here - input
 * type and keyboard stay as they are (keyboard variants are an A/B test, see `numericKeyboard`).
 */
const AUTOCOMPLETE: Record<string, string> = {
  first_name: 'given-name',
  last_name: 'family-name',
  email: 'email',
  phone: 'tel',
  tel: 'tel',
  zip: 'postal-code',
  plz: 'postal-code',
  street: 'street-address',
  city: 'address-level2',
};

export const autocompleteFor = (key?: string): string | undefined => (key ? AUTOCOMPLETE[key] : undefined);
